import { lsGet, safeAwait } from 'utils/request'

export const getPhotoTagByUrlId = async (urlId) => {
  const [data, error] = await safeAwait(lsGet(`/photoTags?urlId=${urlId}`))
  return [data?.[0], error]
}
